import React, { useState } from "react";
import { FiAlignJustify } from "react-icons/fi";
import { IoHomeOutline } from "react-icons/io5";
import { RiAdminLine, RiUserShared2Line } from "react-icons/ri";
import { RiGroupLine } from "react-icons/ri";
import { VscLibrary } from "react-icons/vsc";
import { RxTimer } from "react-icons/rx";
import { AiOutlineAppstoreAdd } from "react-icons/ai";
import { BsGraphUpArrow } from "react-icons/bs";
import { FiDatabase } from "react-icons/fi";
import { IoIosStar } from "react-icons/io";
import { Link } from "react-router-dom";
import { IoPeople } from "react-icons/io5";
import useAuth from "../hooks/useAuth";
import { useSelector } from "react-redux";
import { selectCurrentLogo } from "../features/auth/authSlice";

const iconMap = {
  home: <IoHomeOutline className="text-white text-md" />,
  library: <VscLibrary className="text-white text-md" />,
  admin: <RiAdminLine className="text-white text-md" />,
  group: <RiGroupLine className="text-white text-md" />,
  new: <AiOutlineAppstoreAdd className="text-white text-md" />,
  dataSource: <FiDatabase className="text-white text-md" />,
  favorite: <IoIosStar className="text-white text-md" />,
  recent: <RxTimer className="text-white text-md" />,
  shared: <RiUserShared2Line className="text-white text-md" />,
  trending: <BsGraphUpArrow className="text-white text-md" />,
  meeting: <IoPeople className="text-white text-md" />,
};

const linksArray = [
  {
    label: "Home",
    value: "home",
    path: "/home/dash",
    allowedRoles: ["Viewer", "Explorer", "Creator", "Admin"],
  },
  {
    label: "Library",
    value: "library",
    path: `library/${"root"}`,
    allowedRoles: ["Viewer", "Explorer", "Creator", "Admin"],
  },
  { label: "Admin", value: "admin", path: "admin", allowedRoles: ["Admin"] },
  {
    label: "Group",
    value: "group",
    path: "group",
    allowedRoles: ["Admin"],
  },
  {
    label: "New",
    value: "new",
    path: "/datasource",
    allowedRoles: ["Creator", "Admin", "Explorer"],
  },
  {
    label: "Data Source",
    value: "dataSource",
    path: "editdatasource",
    allowedRoles: ["Creator", "Admin"],
  },
  {
    label: "Favorite",
    value: "favorite",
    path: "favorite",
    allowedRoles: ["Viewer", "Explorer", "Creator", "Admin"],
  },
  {
    label: "Recent",
    value: "recent",
    path: "recent",
    allowedRoles: ["Viewer", "Explorer", "Creator", "Admin"],
  },
  {
    label: "Shared",
    value: "shared",
    path: "shared",
    allowedRoles: ["Viewer", "Explorer", "Creator", "Admin"],
  },
  {
    label: "Trending",
    value: "trending",
    path: "trending",
    allowedRoles: ["Viewer", "Explorer", "Creator", "Admin"],
  },
  {
    label: "Meeting",
    value: "meeting",
    path: "meeting",
    allowedRoles: ["Viewer", "Explorer", "Creator", "Admin"],
  },
];

export default function HomeNav({ open, setOpen }) {
  const { roles } = useAuth();
  const [activePage, setActivePage] = useState("Home");
  const logo = useSelector(selectCurrentLogo);

  const userCompanyDetails = JSON.parse(
    localStorage.getItem("userCompanyDetails")
  );
  const companyLogo = userCompanyDetails?.userCompanylogo;
  const asideHandlerOpen = () => setOpen(!open);

  const filteredLinks = linksArray.filter((link) =>
    link.allowedRoles.some((role) => roles.includes(role))
  );

  return (
    <nav
      className={`navbarGradient font-UberMoveTextRegular shadow-xl h-screen min-h-[70vh] flex flex-col justify-between transition-all duration-300 ${
        open
          ? "w-[20%] sm:w-[15%] md:w-[12.9%]"
          : "w-[3rem] min-w-[3rem] max-w-[3rem]"
      }`}
    >
      <button
        className={`w-full flex items-center p-1 h-[7.5%] ${
          open ? "justify-end" : "justify-center"
        }`}
        onClick={asideHandlerOpen}
      >
        <FiAlignJustify className="text-white text-md" />
      </button>

      <section
        className={`flex items-center justify-center w-full h-[15%]  ${
          open ? "" : ""
        }`}
      >
        {companyLogo ? (
          <img
            src={companyLogo}
            alt="brand_logo"
            className="h-full object-contain p-1 w-[90%]"
          />
        ) : (
          <img
            src={open ? "/graph_img/viztaa.png" : "/graph_img/Group 45.svg"}
            alt="brand_logo"
            className={`w-full p-1 `}
          />
        )}
      </section>

      <section className="text-white flex flex-col justify-start px-2 w-full h-[75%] gap-2 text-sm sm:text-[15px] overflow-y-auto">
        {filteredLinks.map((link, index) => (
          <React.Fragment key={link.value}>
            {link.label === "Favorite" && <hr className="my-2 border-white" />}
            <Link
              to={link.path}
              onClick={() => {
                if (link.value === "library") {
                  sessionStorage.setItem("folderId", "root");
                }
              }}
            >
              <button
                className={`w-full truncate flex items-center gap-1 p-1 ${
                  open ? "justify-start" : "justify-center"
                }`}
              >
                {iconMap[link.value]}
                {open && <span>{link.label}</span>}
              </button>
            </Link>
          </React.Fragment>
        ))}
      </section>

      <footer className="flex items-center justify-center w-full h-[15%]">
        <img
          src={open ? "/graph_img/viztaa.png" : "/graph_img/Group 45.svg"}
          alt="brand_logo"
          className="w-full p-1"
        />
      </footer>
    </nav>
  );
}
